import React from 'react';
import { colors } from '../../styles/styles';

/**
 * Reusable sort button component used throughout the app
 */
const SortButton = ({ onClick, style }) => {
  return (
    <button
      onClick={onClick}
      style={{
        background: 'none',
        border: 'none',
        padding: '4px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '40px',
        ...style
      }}
    >
      <svg 
        width="24" 
        height="24" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M4 6H14M4 12H11M4 18H8M17 8L20 5M20 5L23 8M20 5V19" 
          stroke={colors.textSecondary} 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default SortButton; 